import React from "react";
import { Link } from "react-router-dom";
import ServiceCarousel from "./ServiceCarousel";

// 🔹 Use the same image names you already have in src/assets
import lifeImg from "../assets/icon-life-insurance.jpg";
import incomeImg from "../assets/icon-income-protection.png";
import healthImg from "../assets/icon-health-trauma.png";
import mortgageImg from "../assets/icon-mortgage-protection.png";

const protectionServices = [
  {
    id: "life-insurance",
    title: "Life Insurance",
    tagline: "Family financial protection",
    description:
      "A lump sum paid to your family if you die. Most people size it to clear the mortgage and keep the household running for a few years after that.",
    image: lifeImg,
  },
  {
    id: "income-protection",
    title: "Income Protection",
    tagline: "Salary continuation cover",
    description:
      "If illness or injury keeps you off work for months, this replaces part of your income while you are out. The two things to get right are the waiting period and how long it pays out for.",
    image: incomeImg,
  },
  {
    id: "health-trauma",
    title: "Health & Trauma",
    tagline: "Medical & critical illness",
    description:
      "A lump sum paid when you are diagnosed with a serious condition, so money isn’t the thing on your mind while you recover.",
    image: healthImg,
  },
  {
    id: "mortgage-protection",
    title: "Mortgage Protection",
    tagline: "Home loan payment cover",
    description:
      "Covers the mortgage repayments if illness, injury or redundancy stops you working. What counts as a valid claim varies by policy, so we go through the wording with you first.",
    image: mortgageImg,
  },
];

function ProtectionServicesSection() {
  return (
    <section className="section protection-services-section">
      <div className="section-header">
        <span className="section-kicker">Protection</span>
        <h2 className="section-title">
          Insurance that works alongside your lending.
        </h2>
        <p className="section-subtitle">
          A mortgage runs for up to thirty years and assumes you’ll keep
          earning the whole time. Insurance is for the stretches when you can’t.
        </p>
      </div>

      <ServiceCarousel label="Protection services">
        {protectionServices.map((service) => (
          <div className="protection-loop-card" key={service.id}>
            <div className="protection-card-image">
              <img src={service.image} alt={service.title} />
            </div>

            <div className="protection-card-content">
              <div className="protection-card-tag">{service.tagline}</div>
              <h3 className="protection-card-title">{service.title}</h3>
              <p className="protection-card-description">
                {service.description}
              </p>

              <Link
                to={`/services/${service.id}`}
                className="protection-card-link"
              >
                Learn more about {service.title.toLowerCase()}
              </Link>
            </div>
          </div>
        ))}
      </ServiceCarousel>
    </section>
  );
}

export default ProtectionServicesSection;
